<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uaF6tj/tc-custom/9780813143033.jpg?1705751669980" alt="This image is the cover for the book Historic Kentucky Kitchen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Historic Kentucky Kitchen
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Over 100 old-time recipes “authentic enough that one can easily cook like grandma (or her ma). A must for every kitchen and a nostalgic delight” (<i>Louisville Courier-Journal</i>).</b><br/>  <br/> Kitchens aren’t just a place to prepare food—they’re cornerstones of the home and family. Just as memories are passed down through stories shared around the stove, recipes preserve traditions and customs for future generations.<br/>  <br/><i>The Historic Kentucky Kitchen</i> assembles over one hundred dishes from nineteenth and twentieth-century Kentucky cooks. Deirdre A. Scaggs and Andrew W. McGraw collected recipes from handwritten books, diaries, scrapbook clippings, and out-of-print cookbooks from the University of Kentucky Libraries Special Collections to bring together a variety of classic dishes, complete with descriptions of each recipe’s origin and helpful tips for the modern chef. The authors, who carefully tested each dish, also provide recipe modifications and substitutions for hard-to-find ingredients.<br/>  <br/> This entertaining cookbook also serves up famous Kentuckians’ favorite dishes, including John Sherman Cooper’s preferred comfort food (eggs somerset) and Lucy Hayes Breckinridge’s “excellent” fried oysters. The recipes are flavored with humorous details such as “[for] those who thought they could not eat parsnips” and “Granny used to beat ’em [biscuits] with a musket.” Accented with historic photos and featuring traditional meals ranging from skillet cakes to spaghetti with celery and ham, this is a novel and tasty way to experience the rich, diverse history of the Bluegrass State.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deirdre A. Scaggs, Andrew W. McGraw, John van Willigen
      </h2>
      
      <p class="authorDescription body article">Deirdre A. Scaggs is associate dean of the University of Kentucky Libraries Special Collections Research Center and the author of Women in Lexington.Andrew W. McGraw is the Administrative Specialist for CSI Group.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University Press of Kentucky
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5890b088